import type { FC } from 'react'
import { Focusable } from 'react-aria-components'
import { MediaMentionChipThumb } from 'src/components/GenerationTask/MultiColumnGenerationForm/ImageToVideo/MultiReference/PromptEditor/MediaMentionChipThumb'
import { MediaMentionHoverPreview } from 'src/components/GenerationTask/MultiColumnGenerationForm/ImageToVideo/MultiReference/PromptEditor/MediaMentionHoverPreview'
import { UITooltipResponsive } from 'src/components/HelpIcon'
import { cn } from 'src/utils/cx'
import type { MediaKind } from './mentionMedia'

export const PromptMentionChip: FC<{
  kind: MediaKind
  index: number
  mediaId: string
}> = ({ kind, index, mediaId }) => {
  /**
   * Video chips are intentionally read-only thumbnails in artwork detail.
   * The existing SingleMediaViewer above already plays the artwork's primary
   * video, so there is no useful preview to show on hover.
   */
  const hasPreview = kind === 'image' || kind === 'audio'

  const label = `@${kind}${index}`

  const chipClass = cn(
    'mx-0.5 inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium align-middle outline-none',
    'bg-primary/15 text-primary',
    hasPreview && 'cursor-default',
  )

  const chipBody = (
    <>
      <MediaMentionChipThumb kind={kind} mediaId={mediaId} />
      <span>{label}</span>
    </>
  )

  if (!hasPreview) {
    return <span className={chipClass}>{chipBody}</span>
  }

  return (
    <UITooltipResponsive
      TooltipProps={{ placement: 'top' }}
      trigger={open => (
        <Focusable>
          <span tabIndex={0} onClick={open} className={chipClass}>
            {chipBody}
          </span>
        </Focusable>
      )}
    >
      <MediaMentionHoverPreview kind={kind} mediaId={mediaId} label={label} />
    </UITooltipResponsive>
  )
}
